/**
 * Created by bszggg on 2019. 06. 15..
 */
import moment from 'moment';
import SettingsContainer from '@/helper/SettingsContainer';

/**
 * Helper General functions for all of product parts
 */
const Helper = {
  default_type: "",
  default_presuf: "",
  default_fix: "",
  default_lang: "",
  base_item: "gross", // net gross

  price_number_of_decimals: 2,
  discount_number_of_decimals: 2,
  sumprice_number_of_decimals: 2,
  defaultdtpaymentdeadline: 2,
  ggg: "",

  String: function (data) {
    let retString = String(data);
    if (String(data) === "null") {
      retString = "";
    }
    if (String(data) === "undefined") {
      retString = "";
    }
    if (String(data) === "[object Object]") {
      retString = "";
    }
    return retString
  },
  Number: function (num,covertToString) {
    let retNum = 0;
    try {
      retNum = Number(num);
    } catch (e) {
      retNum = 0;
    }
    if(covertToString){
      if(isNaN(retNum)||isNaN(Helper.Number(retNum))){
        retNum=0;
      }
      retNum=Helper.String(retNum)
    }
    return retNum
  },
  convertAnyToString: function (o,intSpaceLength) {
    let ret=String(o);
    if(o===null){
      ret="";
    }
    if(o===void 0){
      ret="";
    }
    if(intSpaceLength){
      ret=ret.padEnd(intSpaceLength, ' ')
    }
    return ret;
  },
  convertAnyToStringWithContent: function (o) {
    let ret=String(o);
    if(o===null){
      ret=" ";
    }
    if(o===void 0){
      ret=" ";
    }
    return ret;
  },
  getRemovedTrailingZero: function (number) {
    if (typeof number === "undefined") {
      return void 0
    }
    if (typeof number === "null") {
      return null
    }
    return parseFloat(number.toString().replaceAll("\\.0*$", ""))
  },
  getDefaultdtpaymentdeadline: function (data, keys) {
    return Helper.Number(this.defaultdtpaymentdeadline);
  },
  makeFilteredObjectByKeys: function (data, keys) {
    const ret = {};
    if (Array.isArray(keys)) {
      Array.prototype.forEach.call(keys, function (e) {
        ret[e] = data[e];
      })
    }
    return ret;
  },
  makeFilteredArrayByKeys: function (data, keys) {
    const ret = [];
    if (Array.isArray(data)) {
      Array.prototype.forEach.call(data, function (e) {
        ret.push(Helper.makeFilteredObjectByKeys(e, keys));
      })
    }
    return ret;
  },
  getNewUTCDateTime: function () {
    // const date = new Date();
    // return date.toUTCString();
    return moment.utc().format('YYYY-MM-DD HH:mm:ss');
  },
  getDisplaUTCDateTime: function (datestring, format = 'YYYY-MM-DD HH:mm:ss') {
    if (typeof datestring === "string") {
      const dateObj = moment.utc(datestring).local();
      return dateObj.format(format)
    }
  },
  /**
   * A bejelentkezett usernek van-e joga az adott funkcióhoz a saját role-ja alapján
   * @param roles
   * @param user_role
   * @returns {boolean}
   */
  checkRoles: function (roles, user_role = null) {
    // console.log("checkRoles")
    // console.log(roles)
    // console.log(user_role)
    if (Array.isArray(roles)) {
      let rights = false;
      Array.prototype.forEach.call(roles, function (role) {
        // if (role === 0) {
        //     rights = true;
        // }
        if (user_role !== null && user_role.toString() === role.toString()) {
          rights = true;
          // } else if (window.user && window.user.user_role && role && window.user.user_role.toString() === role.toString()) {
          //   rights = true;
        }
      });
      return rights;
    }
  },
  chkRole(modul){
    // const modul = this;
    modul.hasRole = false;
    const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : "ggg";
    if (!Helper.checkRoles(modul.roles, role)) {
      modul.hasRole = false;
//        modul.$router.push({name: "dashboard"})
    } else {
      modul.hasRole = true;
    }
  },

  // user_role -> Ez az user tábla role- mezője
  // partneruserroleId => ez az amit az user role-ú felhasználó adatlapján pipál6unk.. aljogosultságok
  //
  // checkRolesAuto(this, modul tábla azonosító , role tábla azonosító)
  // checkRolesAuto(this, 3,1)               ha admin, és a 3-as modulhoz van joga a cégnek akkor ok,  ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 1-esnek és akkkor oké
  // checkRolesAuto(this, [1,10],13)         Ha admin, és a 1, 10-es modulok valamelyikéhez van joga a cégnek akkor ok, ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 13-esnek és akkkor oké
  //
  // checkRoles([5, 6, 7, 8, 9, 10], user_role)   a user_role benne van-e a felsoroltak között

  /**
   * ha modulId===null akkor nem vizsgáljuk a modul szerinti jogosultságot
   *
   * @param modul
   * @param modulId : int, OR array of int - contains modulId
   * @param partneruserroleId
   * @returns {boolean}
   *
   * paramétererk:   Modul  ,  Modul id vagy modul id-k amikhez ez a cucc tartozik  ,  a minimum user role, ami felett hozzáférhetnek
   */

  checkRolesAuto: function (modul, modulId, partneruserroleId) {
    // console.log("modul.$store.state.user");
    // console.log(modul.$store.state.user);
    const user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
    const partneruserroles = (modul.$store.state && modul.$store.state.partneruserroles ) ? modul.$store.state.partneruserroles : [];
    const moduleRights = (modul.$store.state && modul.$store.state.moduleRights ) ? modul.$store.state.moduleRights : [];

    const partneruserrolesIds = [];
    if (Array.isArray(partneruserroles)) {
      partneruserroles.forEach(function (e, i) {
        if (Number(e.deleted) === 0 && e.id_role) {
          partneruserrolesIds.push(Number(e.id_role))
        }
      })
    }

    const moduleRightsIds = [];
    if (Array.isArray(moduleRights)) {
      moduleRights.forEach(function (e, i) {
        if (Number(e.id_rights) > 0) {
          moduleRightsIds.push(Number(e.modulid))
        }
      })
    }

    // mdulhoz hozzáférés van-e
    if (Array.isArray(moduleRights)) {
      let rights = false;
      Array.prototype.forEach.call(moduleRights, function (moduleRight) {
        if (moduleRight && Array.isArray(modulId) && modulId.indexOf(Number(moduleRight.modulid)) > -1) {
          rights = true;

        } else if (moduleRight && Number(moduleRight.modulid) === Number(modulId)) { // && modulRoles.indexOf(Number(moduleRight.id_rights)) > -1
          rights = true;
        }
      });
      if (modulId === null) {
        rights = true;
      }
      if (!rights) {
        // console.log("nincs modul jog");
        return false;
      }
    }

    // ha admin, akkor mindent
    if (Number(user_role) >= 8) {
      // console.log("van role - admin alapon");
      return true;
    }
    // ha normál user, akkor partneruser role checks
    if (Number(user_role) === 5) {
      if (partneruserrolesIds.indexOf(Number(partneruserroleId)) > -1) {
        // console.log("van role - user partneruserrole alapon");
        return true;
      }
    }

  },
  getModuleRightsIds: function (modul) {
    const moduleRights = (modul.$store.state && modul.$store.state.moduleRights ) ? modul.$store.state.moduleRights : [];
    const moduleRightsIds = [];
    if (Array.isArray(moduleRights)) {
      moduleRights.forEach(function (e, i) {
        if (Number(e.id_rights) > 0) {
          moduleRightsIds.push(Number(e.modulid))
        }
      })
    }
    return moduleRightsIds;
  },

  /**
   * A bejelentkezett userhez tartozó cégnek van-e joga az adott modulhoz
   * @param moduleRights  Modul szintű jogkör adatok a DB-ből, az adott cégnek
   * @param modulId       Modul azonosítója
   * @param modulRoles    Modulhoz felvitt jogosultségi szint. Most még mindenhol 1-es
   * @returns {boolean}
   */
  hasModuleRights: function (moduleRights, modulId, modulRoles) {
    // console.log("hasModuleRights")
    // console.log(moduleRights)
    // console.log(modulId)
    // console.log(modulRoles)
    // const moduleRights = moduleRights;
    if (Array.isArray(moduleRights)) {
      let rights = false;
      Array.prototype.forEach.call(moduleRights, function (moduleRight) {
        if (moduleRight && Number(moduleRight.modulid) === Number(modulId) && modulRoles.indexOf(Number(moduleRight.id_rights)) > -1) {
          rights = true;
        }
      });
      // console.log(rights)
      return rights;
    }
  },


  getValueByIdAndKeyFromObjectArray: function (key, arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = e[key];
      }
    });
    return ret;
  },
  /**
   * Az object-et adja vissza a tömbből, ahol "idKey" megegyezik az "id"-vel
   * Ez arra jó, hogy kikeressük az adott elemet egy query resultból id alapján
   * @param arr
   * @param id
   * @param idKey
   * @returns {*}
   */
  getObjectByIdFromObjectArray: function (arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = e;
      }
    });
    return ret;
  },
  /**
   * Az object id-jét adja vissza a tömbből, ahol "idKey" megegyezik az "id"-vel
   * Ez arra jó, hogy a tömbbe aláfűzzünk még adatokat. Pl invoice alá az invoice_element-eket
   * @param arr
   * @param id
   * @param idKey
   * @returns {*}
   */
  getObjectIndexByIdFromObjectArray: function (arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = i;
      }
    });
    return ret;
  },
  filterObjectByKeys: function (obj, keys) {
    const ret = {};
    Array.prototype.forEach.call(keys, function (el) {
      if (obj.hasOwnProperty(el)) {
        ret[el] = obj[el];
      }
    });
    return ret;
  },


  // invoice-ból áthozva -- át kell írni az ide megfelelőre
  // Pénznemek
  getMoneyDefaultType: function (date) { // HUF USD EUR
    let ret = "";
    // if (localStorage) {
    // ret = localStorage.getItem("money_default_type");
    ret = Helper.default_type;
    // }
    return ret;
  },
  getMoneyDefaultDisplayPrefix: function (date) { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // let presuf = localStorage.getItem("money_default_presuf");
    let presuf = Helper.default_presuf;
    if (presuf === "prefix") {
      // let fix = localStorage.getItem("money_default_fix");
      let fix = Helper.default_fix;
      ret = fix;
    }
    // }
    return ret;
  },
  getMoneyDefaultDisplaySuffix: function (date) { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // let presuf = localStorage.getItem("money_default_presuf");
    let presuf = Helper.default_presuf;
    if (presuf === "suffix") {
      // let fix = localStorage.getItem("money_default_fix");
      let fix = Helper.default_fix;
      ret = fix;
    }
    // }
    return ret;
  },
  getMoneyDefaultDisplayPreSuf: function () { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // ret = localStorage.getItem("money_default_presuf");
    ret = Helper.default_presuf;
    // }
    return ret;
  },

  updateSettings: function () {
    const data = SettingsContainer.getSettings();
    Helper.setMoneys(data)
  },
  // Ez már a saját cloud oldali függvény a selsettingsből.
  setMoneys(data){
    // const modul = this;
    if (Array.isArray(data)) {

      Array.prototype.forEach.call(data, function (e) {
        if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "money") {
          if (e.typec_sub === "default_type") {
            Helper.default_type = e.valuec;
          }
          if (e.typec_sub === "default_presuf") {
            Helper.default_presuf = e.valuec;
          }
          if (e.typec_sub === "default_fix") {
            Helper.default_fix = e.valuec;
          }
          if (e.typec_sub === "price_number_of_decimals") {
            Helper.price_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "discount_number_of_decimals") {
            Helper.discount_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "sumprice_number_of_decimals") {
            Helper.sumprice_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "defaultdtpaymentdeadline") {
            Helper.defaultdtpaymentdeadline = e.valuec;
          }
          if (e.typec_sub === "base_item") {
            Helper.base_item = e.valuec;
          }
        }
      });
      Array.prototype.forEach.call(data, function (e) {
        if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "lang") {
          if (e.typec_sub === "default_lang") {
            Helper.default_lang = e.valuec;
          }
        }
      });
    }
  },
  /**
   * miután egy formázott számnál ha 12,123.123 esetén nem lehet eldönteni, hogy meilyik a tizedes vessző, és melyik a pont, így csak NEM feltöltött számkra alkalmazható a függvény
   * @param price
   */
  getFormattedPriceSegmentation: function (price) { // HUF USD EUR
    Number.prototype.formattedPriceSegmentation = function(n, x, s, c) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };
    // 123456.789456.format(3, 3, ' ', '.');
    if (price === null){
      return price; //"NaN";
    }
    try {
      let retNum = Number(price);
      return retNum.formattedPriceSegmentation(3, 3, ' ', '.');
    } catch (e) {
      return price; //"NaN";
    }


    /*
    // stringgé alakít
    let str = String(price);
    // összes space kidob
    str = str.replace(/ /g, '');
    // hátulról kikeresni az első olyant, ami nem szám (vessző, vagy pont)
    const lastDot = str.lastIndexOf(".");
    const lastComma = str.lastIndexOf(",");
    let lastTag=0;
    let actualSeparator;
    if(lastDot>lastComma){
      lastTag=lastDot;
      actualSeparator=".";
    } else{
      lastTag=lastComma;
      actualSeparator=",";
    }
    let strBeforeSeparator = str.substr(0,lastTag)
    let strAfterSeparator = str.substr(lastTag,str.length)
*/

  },
  getFormattedPrice: function (price) { // HUF USD EUR
    let price_number_of_decimals = 0;
    price_number_of_decimals = Number(Helper.price_number_of_decimals); // Number(localStorage.getItem("price_number_of_decimals"));
    if (isNaN(price_number_of_decimals)) {
      price_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, price_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  getFormattedDiscount: function (price) { // HUF USD EUR
    let discount_number_of_decimals = 0;
    discount_number_of_decimals = Number(Helper.discount_number_of_decimals); // Number(localStorage.getItem("discount_number_of_decimals"));
    if (isNaN(discount_number_of_decimals)) {
      discount_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, discount_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(discount_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  getFormattedSumprice: function (price) { // HUF USD EUR
    let price_number_of_decimals = 0;
    price_number_of_decimals = Number(Helper.sumprice_number_of_decimals); // Number(localStorage.getItem("sumprice_number_of_decimals"));
    if (isNaN(price_number_of_decimals)) {
      price_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, price_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },

  getRoundedNumber: function (number, decimals = 0) { // HUF USD EUR
    let retPrice = number;
    try {
      let szorzo = Math.pow(10, decimals);
      retPrice = Math.round(number * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  pad: function (number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }
  ,checkAppVersion: function (neededAppVersion, actualAppVersion) {
    let hastoRefresh=false;
    const arrNeededAppVersion = neededAppVersion.split(".");
    const arrActualAppVersion = actualAppVersion.split(".");
    if(arrNeededAppVersion.length===3 && arrActualAppVersion.length===3 ){
      if(Helper.Number(arrNeededAppVersion[0]) > Helper.Number(arrActualAppVersion[0])){
        hastoRefresh=true;
      } else {
        if(Helper.Number(arrNeededAppVersion[1]) > Helper.Number(arrActualAppVersion[1])){
          hastoRefresh=true;
        } else {
          if(Helper.Number(arrNeededAppVersion[2]) > Helper.Number(arrActualAppVersion[2])){
            hastoRefresh=true;
          }
        }
      }
    }
    return hastoRefresh;
  },
  // focusNextInputElement: function () {
  // // TODO need fix as getfocusNextInputElement if we want to use
  //   //add all elements we want to include in our selection
  //   const focussableElements = ' input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'; // a:not([disabled]), button:not([disabled]),
  //   if (document.activeElement && document.activeElement.form) {
  //     const focussable = Array.prototype.filter.call(document.activeElement.form.querySelectorAll(focussableElements),
  //       function (element) {
  //         //check for visibility while always include the current activeElement
  //         return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
  //       });
  //     const index = focussable.indexOf(document.activeElement);
  //     if (index > -1) {
  //       const nextElement = focussable[index + 1] || focussable[0];
  //       nextElement.focus();
  //     }
  //   } else if (document.activeElement && !document.activeElement.form) {
  //     const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
  //       function (element) {
  //         //check for visibility while always include the current activeElement
  //         return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
  //       });
  //     const index = focussable.indexOf(document.activeElement);
  //     if (index > -1) {
  //       var nextElement = focussable[index + 1] || focussable[0];
  //       nextElement.focus();
  //     }
  //   }
  // },
  getfocusNextInputElement: function (activeElement) {
    //add all elements we want to include in our selection
    const focussableElements = ' input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'; // a:not([disabled]), button:not([disabled]),
    if(!activeElement){
      activeElement = document.activeElement;
    }
    if (activeElement && activeElement.form) {
      const focussable = Array.prototype.filter.call(activeElement.form.querySelectorAll(focussableElements),
        function (element) {
          //check for visibility while always include the current activeElement
          return element.offsetWidth > 0 || element.offsetHeight > 0 || element === activeElement
        });
      const index = focussable.indexOf(activeElement);
      if (index > -1) {
        const nextElement = focussable[index + 1] || focussable[0];
        // nextElement.focus();
        return nextElement
      }
    } else if (activeElement && !activeElement.form) {
      const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
        function (element) {
          //check for visibility while always include the current activeElement
          return element.offsetWidth > 0 || element.offsetHeight > 0 || element === activeElement
        });
      const index = focussable.indexOf(activeElement);
      if (index > -1) {
        const nextElement = focussable[index + 1] || focussable[0];
        return nextElement
      }
    }
  },
  displayfn_from_taxnumber: function (value) {
  const modul = this;
//        const  pattern ="[0-9]{8}[-][0-9]{8}[-][0-9]{8}|[0-9]{8}[-][0-9]{8}|[A-Z]{2}[0-9]{2}[0-9A-Za-z]{11,30}"; // bank account regexp
//        const pattern = "/(\d{7})(\d)\-([1-5])\-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)|(\d{7})(\d)/"; Elvileg ez nem jó
//        const pattern = "/(\d{8})\-([1-5])\-(\d{2})|(\d{8})/";
//        const pattern = "/([0-9]{8})\-([1-5])\-([0-9]{2})|([0-9]{8})/";
//        const regexp = new RegExp(pattern);
//        let ret = false
//        if (regexp.test(value)) {
//          ret = true;
//        } else {
//          ret = false;
//        }

  let ret = false
  const patternHu1 = "([0-9]{8})\-([1-5])\-([0-9]{2})";
  const regexpHu1 = new RegExp(patternHu1);
  const patternHu2 = "[0-9]{8}";
  const regexpHu2 = new RegExp(patternHu2);

  const patternIe1 = "[0-9]{7}[a-zA-Z]{1}";
  const regexpIe1 = new RegExp(patternIe1);
  const patternIe2 = "[0-9]{7}[a-zA-Z]{2}";
  const regexpIe2 = new RegExp(patternIe2);
  const patternIe3 = "[a-zA-Z]{3}[0-9]{4}";
  const regexpIe3 = new RegExp(patternIe3);
  const patternIe4 = "[a-zA-Z]{3}[ ][0-9]{4}";
  const regexpIe4 = new RegExp(patternIe4);
  if(
    (regexpHu1.test(value) && value.length===13)
    ||
    (regexpHu2.test(value) && value.length===8)
    ||
    (regexpIe1.test(value) && value.length===8)
    ||
    (regexpIe2.test(value) && value.length===9)
    ||
    (regexpIe3.test(value) && value.length===7)
    ||
    (regexpIe4.test(value) && value.length===8)
  ){
    ret = true;
  } else {
    ret = false;
  }
  return ret;
}


};

export default Helper;
